import axios from './axios';
import { buildQuery, Query } from '../utils/query';
import { WifiSeamThermostat, WifiThermostat } from '../redux/types/wifiThermostats';

export function loadWifiThermostats(query: Query = {}) {
  const params = buildQuery(query);
  const endpoint = '/wifi-thermostats';
  const url = params ? `${endpoint}${params}` : endpoint;
  return axios.get<WifiThermostat[]>(url);
}

export function loadWifiThermostatDetails(id: string | number) {
  return axios.get<WifiSeamThermostat>(`/wifi-thermostats/${id}`);
}
